// extracted by mini-css-extract-plugin
export default {"availabilityContainer":"Availability_availabilityContainer__6Voys","availability":"Availability_availability__4isqo","availabilityText":"Availability_availabilityText__3m-xr"};